const CLASSNAME = 'pp-registration-form';

const INIT_FORM_STATE = {
  title: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  firstname: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  lastname: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  jobTitle: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  company: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  tel: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  industry: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  email: {
    value: '',
    error: null,
    validationMessage: 'EMAIL_VALIDATION_MESSAGE',
    isRequired: true
  },
  address1: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  address2: { value: '', error: null },
  postcode: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  country: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  county: {
    value: ''
  },
  city: {
    value: '',
    error: null,
    validationMessage: 'GENERIC_VALIDATION_MESSAGE',
    isRequired: true
  },
  password: {
    value: '',
    error: null,
    validationMessage: 'PASSWORD_VALIDATION_MESSAGE',
    isRequired: true
  },
  passwordConfirm: {
    value: '',
    error: null,
    validationMessage: 'PASSWORD_CONFIRM_VALIDATION_MESSAGE',
    isRequired: true
  },
  tocAccepted: {
    value: false,
    error: null,
    isRequired: true,
    validationMessage: 'TOC_VALIDATION_MESSAGE'
  }
};

export { INIT_FORM_STATE, CLASSNAME };
